exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#nav-buttons > li {\n    border-radius: 4px;\n    height: 50px;\n}\n\n#alert-unset-core-options {\n    text-align: left;\n}", ""]);

